import type {ICar} from '../interfaces/ICar';
import { useParams, Navigate } from 'react-router-dom';
import Cars from '../constants/Cars';
import Material from '../components/Material';
import Box from '@mui/material/Box';
import '../css/cardetail.scss';

type TParams = { id?: string };

const CarDetail = () => {
  const { id } = useParams<TParams>();

  // Sélection de la voiture à partir du paramètre d'URL
  // Assure-toi que Cars est bien typé en ICar[]
  const car: ICar | undefined = Cars.find((item: ICar) => String(item.id) === String(id));

  if (!id || !car) {
    return <Navigate to="/cars" replace />;
  }

  return (
    <Box className="car-detail content-width">
      <h1>{car.marque}</h1>

      <img src={`/${car.image}`} alt={car.imageAlt} />

      <p>Nombres de places : {car.nbPlaces}</p>

      {car.equipement?.length > 0 ? (
        <Material equipements={car.equipement} />
      ) : (
        <div />
      )}

    </Box>
  );
};

export default CarDetail;
